import {isDevMode, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'imgUrl'
})
export class ImgUrlPipe implements PipeTransform {

    transform(value: string): string {
        if (isDevMode()) {
            return 'http://backend.test.prostolab.ru/' + value;
        }
        return value;
    }

}
